import Link from 'next/link'
import slugify from 'slugify'
import classnames from 'classnames'

import Card from 'components/saquon/card'
import Wrapper from 'components/saquon/wrapper'
import SectionFooterSeparator from 'components/saquon/section-footer-separator'
import { Typography, Icon, Button, Mobile } from '~ui'
import buttonStyles from '~ui/Button/Button.module.scss'
import { auctions, cards } from '../data'
import styles from './Experience.module.scss'

const { Text } = Typography

const ExperienceSection = () => (
  <section id="gameday">
    <Wrapper>
      <div className={styles.wrapper}>
        <h2 className={styles.title}>
          <Icon name="double-left-arrow" fill="currentColor" width="1em" height="1em" />
          <div>The Gameday Experiences</div>
          <Icon name="double-right-arrow" fill="currentColor" width="1em" height="1em" />
        </h2>
        <div className={styles.subtitle}>
          <Text color="g-white" size="lg" center>
            Bid on the experience of a lifetime by choosing your favorite access package(s) from
            each of the 8 New York Giants home games listed below. Each home game features a
            different limited edition Saquon Barkley Rookie NFT, exclusively provided on Granted.
          </Text>
        </div>

        <div className={styles.cards}>
          {cards.map((item) => (
            <Card key={item.title} {...item}>
              <Mobile>
                <Link href="#choose-your-game" legacyBehavior>
                  <a>
                    <Button tabIndex={-1} variant="primary">
                      Choose Game
                    </Button>
                  </a>
                </Link>
              </Mobile>
            </Card>
          ))}
        </div>

        <div className={styles.bottom}>
          <div id="choose-your-game">
            <Text color="g-green" size="lg" bold>
              Choose your game:
            </Text>
          </div>
          <div className={styles.buttons}>
            {auctions.map(({ title, linkTitle }) => (
              <Link href={`#${slugify(title)}`} key={slugify(title)} legacyBehavior>
                <a className={classnames(buttonStyles.button, buttonStyles.primary)}>{linkTitle}</a>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </Wrapper>
    <SectionFooterSeparator />
  </section>
)

export default ExperienceSection
